import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import styled from 'styled-components';

import ThemeColor from './ThemeColor';

interface LoadingProps {
  isLoading: boolean;
  children?: React.ReactNode;
}

const LoadingContainer = styled.div`
  width: 100vw;
  height: 100vh;

  z-index: 4;

  position: fixed;
  top: 0;
  left: 0;

  background-color: #f8fafc;

  display: flex;
  justify-content: center;
  align-items: center;
`;

const Loading: React.FC<LoadingProps> = ({ isLoading, children }) => {
  return (
    <>
      {isLoading ? (
        <ThemeColor color="gray">
          <LoadingContainer>
            <ClipLoader color="#1D4ED8" size={200} />
          </LoadingContainer>
        </ThemeColor>
      ) : (
        children
      )}
    </>
  );
};

export default Loading;
